// Static action catalog for the command palette. Shape:
//   { id, label, group, keywords?, path, access? }
// `access` is the RBAC key from menus; palette filters by user's accesses list.
// `keywords` are extra match terms beyond `label`.

export const STATIC_ACTIONS = [
    // Brands (v2)
    { id: 'accounts', label: 'Accounts', group: 'Brands', path: '/brands-v2/accounts', access: 'accounts-v2' },
    { id: 'orders', label: 'Orders', group: 'Brands', path: '/brands-v2/orders', access: 'orders-v2' },
    {
        id: 'product-review',
        label: 'Product review',
        group: 'Brands',
        keywords: 'products in review',
        path: '/brands-v2/review/products/in-review',
        access: 'products-v2'
    },
    {
        id: 'custom-creatives-review',
        label: 'Custom creatives review',
        group: 'Brands',
        path: '/brands-v2/custom-creatives/in-review',
        access: 'custom-creatives-v2'
    },
    {
        id: 'creative-settings',
        label: 'Creative settings',
        group: 'Brands',
        path: '/brands-v2/creative-settings',
        access: 'creative-settings-v2'
    },
    {
        id: 'brief',
        label: 'Brief',
        group: 'Brands',
        keywords: 'analytics dashboard',
        path: '/brands-v2/brief',
        access: 'brief-v2'
    },
    {
        id: 'privacy',
        label: 'Customer privacy',
        group: 'Brands',
        keywords: 'data requests ccpa',
        path: '/brands-v2/privacy',
        access: 'privacy-v2'
    },
    {
        id: 'uplift-studies',
        label: 'Uplift studies',
        group: 'Brands',
        path: '/brands-v2/uplift-studies',
        access: 'uplift-studies-v2'
    },

    // KCP
    { id: 'kcp-accounts', label: 'Accounts', group: 'KCP', path: '/kcp/accounts', access: 'accounts-kcp' },
    {
        id: 'kcp-advertise-generators',
        label: 'Advertise · Generators',
        group: 'KCP',
        path: '/kcp/advertise/generators',
        access: 'advertise-generators'
    },
    {
        id: 'kcp-advertise-strategies',
        label: 'Advertise · Strategies',
        group: 'KCP',
        path: '/kcp/advertise/strategies',
        access: 'advertise-strategies'
    },
    {
        id: 'kcp-giftly-customers',
        label: 'Giftly · Customers',
        group: 'KCP',
        path: '/kcp/giftly/customers',
        access: 'giftly-customers'
    },
    {
        id: 'kcp-giftly-gs-explorer',
        label: 'Giftly · GS Explorer',
        group: 'KCP',
        path: '/kcp/giftly/gs-explorer',
        access: 'giftly-gs-explorer'
    },
    {
        id: 'kcp-giftly-invite-codes',
        label: 'Giftly · Invite codes',
        group: 'KCP',
        path: '/kcp/giftly/invite-codes',
        access: 'giftly-invite-codes'
    },
    {
        id: 'kcp-giftly-tasks',
        label: 'Giftly · Tasks',
        group: 'KCP',
        path: '/kcp/giftly/tasks',
        access: 'giftly-tasks'
    },
    { id: 'kcp-publishers', label: 'Publishers', group: 'KCP', path: '/kcp/publishers', access: 'publishers' },
    { id: 'kcp-rewards', label: 'Rewards', group: 'KCP', path: '/kcp/rewards', access: 'rewards' },
    { id: 'kcp-upsells', label: 'Upsells', group: 'KCP', path: '/kcp/upsells', access: 'upsells' },

    // Notifications
    {
        id: 'notif-automations',
        label: 'Automations',
        group: 'Notifications',
        path: '/notifications/automations',
        access: 'automations'
    },
    {
        id: 'notif-ban-list',
        label: 'Ban list',
        group: 'Notifications',
        path: '/notifications/ban-list',
        access: 'ban-list'
    },
    {
        id: 'notif-campaigns',
        label: 'Campaigns',
        group: 'Notifications',
        path: '/notifications/campaigns',
        access: 'campaigns'
    },
    {
        id: 'notif-conditions',
        label: 'Conditions',
        group: 'Notifications',
        path: '/notifications/conditions',
        access: 'conditions'
    },
    {
        id: 'notif-mailing-lists',
        label: 'Mailing lists',
        group: 'Notifications',
        path: '/notifications/mailing-lists',
        access: 'mailing-lists'
    },
    {
        id: 'notif-service-mails',
        label: 'Service mails',
        group: 'Notifications',
        path: '/notifications/service-mails',
        access: 'service-mails'
    },
    {
        id: 'notif-templates',
        label: 'Templates',
        group: 'Notifications',
        path: '/notifications/templates',
        access: 'templates'
    },
    {
        id: 'notif-triggers',
        label: 'Triggers',
        group: 'Notifications',
        path: '/notifications/triggers',
        access: 'triggers'
    },

    // System. Note: the old per-page routes (/system/cache-sync, /system/script-tags,
    // /system/web-pixels, /system/setup-webhooks, /system/ecommerce-scope-sync,
    // /system/es-migrations) were consolidated into a single tabbed page at
    // /system/sync — each entry below surfaces the tab's label for search, but
    // they all navigate to the same route. The user then clicks the tab.
    {
        id: 'sys-admin-users',
        label: 'Admin users',
        group: 'System',
        path: '/system/admin-users',
        access: 'admin-users'
    },
    { id: 'sys-cron-jobs', label: 'Cron jobs', group: 'System', path: '/system/cron-jobs', access: 'cron-jobs' },
    {
        id: 'sys-dsp-settings',
        label: 'DSP settings',
        group: 'System',
        path: '/system/dsp/settings',
        access: 'dsp-settings'
    },
    {
        id: 'sys-priority-calculator',
        label: 'Priority calculator',
        group: 'System',
        path: '/system/priority-calculator',
        access: 'priority-calculator'
    },
    { id: 'sys-sync', label: 'Sync', group: 'System', path: '/system/sync', access: 'sync' },
    {
        id: 'sys-sync-script-tags',
        label: 'Script tags',
        sublabel: 'System · Sync',
        group: 'System',
        keywords: 'script tag pixel install',
        path: '/system/sync',
        access: 'sync'
    },
    {
        id: 'sys-sync-web-pixels',
        label: 'Web pixels',
        sublabel: 'System · Sync',
        group: 'System',
        path: '/system/sync',
        access: 'sync'
    },
    {
        id: 'sys-sync-cache',
        label: 'Cache sync',
        sublabel: 'System · Sync',
        group: 'System',
        keywords: 'cache invalidate refresh',
        path: '/system/sync',
        access: 'sync'
    },
    {
        id: 'sys-sync-webhooks',
        label: 'Setup webhooks',
        sublabel: 'System · Sync',
        group: 'System',
        keywords: 'webhook setup',
        path: '/system/sync',
        access: 'sync'
    },
    {
        id: 'sys-sync-scopes',
        label: 'Scope sync',
        sublabel: 'System · Sync',
        group: 'System',
        keywords: 'ecommerce scope',
        path: '/system/sync',
        access: 'sync'
    },
    {
        id: 'sys-sync-es',
        label: 'ES migrations',
        sublabel: 'System · Sync',
        group: 'System',
        keywords: 'elastic search migration',
        path: '/system/sync',
        access: 'sync'
    }
];

const normalize = (s) => (s || '').toLowerCase().trim();

// Fuzzy-ish match: every whitespace-separated token in `query` must appear
// somewhere in `label + keywords + group`. Good enough for a small catalog —
// if the catalog grows past ~100 entries, swap in fuse.js.
export const filterStaticActions = (actions, query) => {
    const q = normalize(query);
    if (!q) return actions;
    const tokens = q.split(/\s+/).filter(Boolean);
    return actions.filter((action) => {
        const haystack = normalize(`${action.label} ${action.keywords || ''} ${action.group}`);
        return tokens.every((t) => haystack.includes(t));
    });
};

export const filterByAccess = (actions, accesses) => {
    if (!accesses) return [];
    if (accesses.includes('*')) return actions;
    return actions.filter((a) => !a.access || accesses.includes(a.access));
};
